export const getModalShown = state => {
  return state.modalShown;
};
export const getModalInstance = state => {
  return state.modalInstance;
};